import { RedoCarrierName } from "@redotech/redo-model/carrier-account/carrier-account";

export function getFilteredCarrierOptions({
  carrierOptions,
  checkoutOptimizationEnabled = false,
  newOmsEnabled = false,
  sendcloudByoaEnabled = false,
}: {
  carrierOptions: RedoCarrierName[];
  checkoutOptimizationEnabled?: boolean;
  newOmsEnabled?: boolean;
  sendcloudByoaEnabled?: boolean;
}): RedoCarrierName[] {
  const filteredForOms = carrierOptions.filter(
    (carrier) =>
      carrier !== RedoCarrierName.USPS && carrier !== RedoCarrierName.USPS_SHIP,
  );
  const filteredForReturns = carrierOptions.filter(
    (carrier) => carrier !== RedoCarrierName.USPS_DIRECT,
  );

  const filtered =
    newOmsEnabled || checkoutOptimizationEnabled
      ? filteredForOms
      : filteredForReturns;

  // Sendcloud BYOA is gated per team (default OFF) — hide it as an addable
  // carrier until the team is enabled in LaunchDarkly.
  const filteredForSendcloud = sendcloudByoaEnabled
    ? filtered
    : filtered.filter((carrier) => carrier !== RedoCarrierName.SENDCLOUD);

  return filteredForSendcloud.sort((a, b) => a.localeCompare(b));
}
